var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQualifiers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 70,
    viewBox: "0 0 312 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3925_130671",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -38,
    width: 312,
    height: 231
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 312,
    height: 230.504,
    transform: "matrix(-1 0 0 1 312 -37.541)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3925_130671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.3801 192.964H222.715C259.467 138.433 277.608 100.989 278.243 19.0153L278.243 -37.541H-15.3801V192.964Z",
    fill: "#304FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.9359 192.964H150.008C185.562 159.407 236.697 108.472 243.687 4.60501L243.688 -37.541H-49.9359V192.964Z",
    fill: "#B287FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84.2918 192.964H35.5545C91.0833 178.582 205.137 107.074 209.332 -37.541H-84.2918V192.964Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-122.243 146.223C-122.243 146.223 -98.8731 170.193 -2.39687 146.223C94.0794 122.254 155.6 51.9443 171.38 -37.5409C187.16 -127.026 -122.243 -37.5409 -122.243 -37.5409V146.223Z",
    fill: "#4A148C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-153.987 101.303C-153.987 101.303 -130.617 125.272 -34.1406 101.303C62.3356 77.3338 123.857 7.02399 139.637 -82.4612C155.416 -171.946 -153.987 -82.4612 -153.987 -82.4612V101.303Z",
    fill: "#D60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-181.951 52.5656C-181.951 52.5656 -158.581 76.5348 -62.1048 52.5656C34.3715 28.5963 95.8926 -41.7136 111.672 -131.199C127.452 -220.684 -181.951 -131.199 -181.951 -131.199V52.5656Z",
    fill: "#B0EB00"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualifiers);
export default __webpack_public_path__ + "static/media/qualifiers.2e048292c9ecf0ade2080f8c33e15525.svg";
export { ForwardRef as ReactComponent };